import React from 'react'
import { DropdownList, DropdownItem } from './styles'
import { Button } from 'components/UI/Button'

export interface MenuOption {
  text: string
  onClick?: any
  variant?: 'text' | 'text-danger'
}

interface Props {
  menuOptions: MenuOption[]
  id?: any
}

const DropdownMenu: React.FC<Props> = ({ menuOptions, id }) => {
  if (!menuOptions || menuOptions.length === 0) {
    return null
  }

  const onClick = (item: any) => {
    if (id) {
      item.onClick(id)
    } else {
      item.onClick()
    }
  }

  return (
    <DropdownList>
      {menuOptions.map(item => (
        <DropdownItem key={item.text}>
          {/* tslint:disable-next-line:jsx-no-lambda */}
          <Button variant={item.variant || 'text'} onClick={() => onClick(item)}>
            {item.text}
          </Button>
        </DropdownItem>
      ))}
    </DropdownList>
  )
}

export default DropdownMenu
